Element.prototype.isNodeList = function() {return false;}
NodeList.prototype.isNodeList = HTMLCollection.prototype.isNodeList = function(){return true;}

module.exports = listen = ( selection, fn, interaction ) => {
    interaction = interaction || 'click';
    fn = fn || function (e) { console.log( this, e ) };
    selection = typeof selection === 'string' || selection instanceof String ? document.querySelectorAll(selection) : selection;
    if( selection.isNodeList() ) {
        //check list length once
        const list = selection.length;
        for (let index = 0; index < list; index++) {
            const element = selection[index]; 
            element.addEventListener( interaction, fn ) 
        } 
    } else {
        selection.addEventListener( interaction, fn )
    }
} 